/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Footer_Back_TopInputs */

const en_gc_footer_back_top = /** @type {(inputs: Gc_Footer_Back_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to top`)
};

const zh_gc_footer_back_top = /** @type {(inputs: Gc_Footer_Back_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回顶部`)
};

/**
* | output |
* | --- |
* | "Back to top" |
*
* @param {Gc_Footer_Back_TopInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_footer_back_top = /** @type {((inputs?: Gc_Footer_Back_TopInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Footer_Back_TopInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_footer_back_top(inputs)
	return zh_gc_footer_back_top(inputs)
});
export { gc_footer_back_top as "gc.footer.back_top" }